import React from "react";

/**
 * Catches render/lifecycle errors from its subtree so one failing component
 * cannot unmount the whole app (React 18 blanks the page otherwise).
 *
 * `fallback` may be a node or a ({ error, reset }) => node render function.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled UI error:", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    const { children, fallback = null } = this.props;

    if (!error) return children;

    if (typeof fallback === "function") {
      return fallback({ error, reset: this.handleReset });
    }
    return fallback;
  }
}
